Auth = require 'db/auth'
getAudienceDefinitions = require('common/lib/experiments/audience-definitions').default

module.exports = getAudienceDefinitions(-> if me = Auth.me() then me.toJSON() else null)



// WEBPACK FOOTER //
// ./app/scripts/lib/experiments/audience-definitions.coffee